var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-row',{staticClass:"friend-item-container"},[_c('el-col',{attrs:{"span":6}},[_c('avatar',{attrs:{"src":_vm.friend.profile.avatar}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":18}},[_c('div',{staticClass:"friend-name"},[_vm._v(_vm._s(_vm.friend.profile.nick||_vm.friend.userID))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72326b30","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/im/friend/friend-item.vue
// module id = null
// module chunks = 